import apiClient from './api/client';
import ENDPOINTS from './api/endpoints';

const USE_MOCK = false;

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

// ── Waste Categories ────────────────────────────────────────────
const WASTE_CATEGORIES = [
  { value: 'spoilage', label: 'Spoilage / Expired' },
  { value: 'over_preparation', label: 'Over-Preparation' },
  { value: 'damage', label: 'Damage' },
  { value: 'plate_waste', label: 'Plate Waste' },
  { value: 'theft_shrinkage', label: 'Theft / Shrinkage' },
  { value: 'other', label: 'Other' },
];

// ── Mock Inventory Items ────────────────────────────────────────
const mockInventoryItems = [
  { id: 1, name: 'Basmati Rice', uom: 'kg', uomSymbol: 'kg', currentStock: 48.5, unitCost: 80 },
  { id: 2, name: 'Chicken', uom: 'kg', uomSymbol: 'kg', currentStock: 12.0, unitCost: 280 },
  { id: 3, name: 'Mutton', uom: 'kg', uomSymbol: 'kg', currentStock: 6.5, unitCost: 550 },
  { id: 4, name: 'Fish (Rohu)', uom: 'kg', uomSymbol: 'kg', currentStock: 4.0, unitCost: 350 },
  { id: 5, name: 'Onions', uom: 'kg', uomSymbol: 'kg', currentStock: 35.0, unitCost: 30 },
  { id: 6, name: 'Tomatoes', uom: 'kg', uomSymbol: 'kg', currentStock: 22.0, unitCost: 40 },
  { id: 7, name: 'Paneer', uom: 'kg', uomSymbol: 'kg', currentStock: 8.0, unitCost: 320 },
  { id: 8, name: 'Butter', uom: 'kg', uomSymbol: 'kg', currentStock: 3.5, unitCost: 450 },
  { id: 9, name: 'Fresh Cream', uom: 'L', uomSymbol: 'L', currentStock: 5.0, unitCost: 250 },
  { id: 10, name: 'Yogurt', uom: 'kg', uomSymbol: 'kg', currentStock: 7.0, unitCost: 100 },
  { id: 11, name: 'Cooking Oil', uom: 'L', uomSymbol: 'L', currentStock: 15.0, unitCost: 120 },
  { id: 12, name: 'Ghee', uom: 'kg', uomSymbol: 'kg', currentStock: 4.0, unitCost: 500 },
  { id: 13, name: 'Garam Masala', uom: 'kg', uomSymbol: 'kg', currentStock: 2.5, unitCost: 800 },
  { id: 14, name: 'Turmeric Powder', uom: 'kg', uomSymbol: 'kg', currentStock: 3.0, unitCost: 300 },
  { id: 15, name: 'Red Chilli Powder', uom: 'kg', uomSymbol: 'kg', currentStock: 2.8, unitCost: 400 },
];

// ── Mock Waste Entries ──────────────────────────────────────────
let nextWasteId = 16;

let mockWasteEntries = [
  { id: 1, itemId: 2, itemName: 'Chicken', quantity: 1.5, uom: 'kg', unitCost: 280, costImpact: 420, wasteCategory: 'spoilage', reason: 'Left out overnight, turned bad', loggedBy: 'Admin', createdAt: '2026-03-05T08:30:00Z' },
  { id: 2, itemId: 6, itemName: 'Tomatoes', quantity: 3.0, uom: 'kg', unitCost: 40, costImpact: 120, wasteCategory: 'spoilage', reason: 'Overripe batch', loggedBy: 'Rahul', createdAt: '2026-03-05T09:15:00Z' },
  { id: 3, itemId: 7, itemName: 'Paneer', quantity: 0.5, uom: 'kg', unitCost: 320, costImpact: 160, wasteCategory: 'over_preparation', reason: 'Extra prep for cancelled party order', loggedBy: 'Admin', createdAt: '2026-03-05T11:00:00Z' },
  { id: 4, itemId: 9, itemName: 'Fresh Cream', quantity: 0.8, uom: 'L', unitCost: 250, costImpact: 200, wasteCategory: 'spoilage', reason: 'Past expiry date', loggedBy: 'Priya', createdAt: '2026-03-04T14:20:00Z' },
  { id: 5, itemId: 3, itemName: 'Mutton', quantity: 1.0, uom: 'kg', unitCost: 550, costImpact: 550, wasteCategory: 'damage', reason: 'Freezer temperature dropped', loggedBy: 'Admin', createdAt: '2026-03-04T10:00:00Z' },
  { id: 6, itemId: 1, itemName: 'Basmati Rice', quantity: 2.0, uom: 'kg', unitCost: 80, costImpact: 160, wasteCategory: 'damage', reason: 'Water leak damaged storage', loggedBy: 'Rahul', createdAt: '2026-03-03T16:30:00Z' },
  { id: 7, itemId: 5, itemName: 'Onions', quantity: 4.0, uom: 'kg', unitCost: 30, costImpact: 120, wasteCategory: 'spoilage', reason: 'Sprouted in storage', loggedBy: 'Admin', createdAt: '2026-03-03T09:45:00Z' },
  { id: 8, itemId: 2, itemName: 'Chicken', quantity: 0.8, uom: 'kg', unitCost: 280, costImpact: 224, wasteCategory: 'plate_waste', reason: 'Returned orders — undercooked complaints', loggedBy: 'Priya', createdAt: '2026-03-02T20:30:00Z' },
  { id: 9, itemId: 8, itemName: 'Butter', quantity: 0.3, uom: 'kg', unitCost: 450, costImpact: 135, wasteCategory: 'over_preparation', reason: 'Excess butter sauce prep', loggedBy: 'Admin', createdAt: '2026-03-02T12:00:00Z' },
  { id: 10, itemId: 13, itemName: 'Garam Masala', quantity: 0.2, uom: 'kg', unitCost: 800, costImpact: 160, wasteCategory: 'theft_shrinkage', reason: 'Unaccounted shortage during audit', loggedBy: 'Admin', createdAt: '2026-03-01T17:00:00Z' },
  { id: 11, itemId: 4, itemName: 'Fish (Rohu)', quantity: 1.2, uom: 'kg', unitCost: 350, costImpact: 420, wasteCategory: 'spoilage', reason: 'Not used within freshness window', loggedBy: 'Rahul', createdAt: '2026-03-01T08:00:00Z' },
  { id: 12, itemId: 10, itemName: 'Yogurt', quantity: 1.5, uom: 'kg', unitCost: 100, costImpact: 150, wasteCategory: 'spoilage', reason: 'Expired stock', loggedBy: 'Admin', createdAt: '2026-02-28T15:00:00Z' },
  { id: 13, itemId: 6, itemName: 'Tomatoes', quantity: 2.0, uom: 'kg', unitCost: 40, costImpact: 80, wasteCategory: 'plate_waste', reason: 'Garnish leftover from buffet', loggedBy: 'Priya', createdAt: '2026-02-28T21:00:00Z' },
  { id: 14, itemId: 11, itemName: 'Cooking Oil', quantity: 2.0, uom: 'L', unitCost: 120, costImpact: 240, wasteCategory: 'other', reason: 'Used oil disposal', loggedBy: 'Admin', createdAt: '2026-02-27T18:00:00Z' },
  { id: 15, itemId: 7, itemName: 'Paneer', quantity: 1.0, uom: 'kg', unitCost: 320, costImpact: 320, wasteCategory: 'over_preparation', reason: 'Weekend special not sold as expected', loggedBy: 'Rahul', createdAt: '2026-02-27T14:00:00Z' },
];

// ── Helper: Generate daily trend data ───────────────────────────
const generateDailyTrend = (days) => {
  const trend = [];
  const today = new Date('2026-03-05');
  for (let i = days - 1; i >= 0; i--) {
    const date = new Date(today);
    date.setDate(date.getDate() - i);
    const dateStr = date.toISOString().split('T')[0];
    const dayEntries = mockWasteEntries.filter((e) => e.createdAt.startsWith(dateStr));
    trend.push({
      date: dateStr,
      label: date.toLocaleDateString('en-IN', { day: 'numeric', month: 'short' }),
      cost: dayEntries.reduce((sum, e) => sum + e.costImpact, 0),
      count: dayEntries.length,
    });
  }
  // Fill empty days with random realistic data
  trend.forEach((d) => {
    if (d.cost === 0) {
      d.cost = Math.round(200 + Math.random() * 600);
      d.count = Math.round(1 + Math.random() * 3);
    }
  });
  return trend;
};

// ── Service ─────────────────────────────────────────────────────
const wasteTrackingService = {
  async logWaste(payload) {
    if (USE_MOCK) {
      await delay(500);
      const item = mockInventoryItems.find((i) => i.id === payload.inventoryItemId);
      if (!item) throw new Error('Item not found');
      const costImpact = Math.round(payload.quantity * item.unitCost);
      const entry = {
        id: nextWasteId++,
        itemId: item.id,
        itemName: item.name,
        quantity: payload.quantity,
        uom: item.uom,
        unitCost: item.unitCost,
        costImpact,
        wasteCategory: payload.wasteCategory,
        reason: payload.reason || '',
        loggedBy: 'Admin',
        createdAt: new Date().toISOString(),
      };
      mockWasteEntries.unshift(entry);
      item.currentStock = Math.max(0, item.currentStock - payload.quantity);
      return entry;
    }
    console.log(' wasteTrackingService.logWaste - Sending payload:', payload);
  console.log(' POST endpoint:', ENDPOINTS.WASTE_TRACKING.CREATE);

  try {
    const normalizedCat = String(payload.wasteCategory || '').trim().toLowerCase();
    const res = await apiClient.post(ENDPOINTS.WASTE_TRACKING.CREATE, {
      inventoryItemId: payload.inventoryItemId,
      quantity: payload.quantity,
      wasteCategory: normalizedCat,
      reason: payload.reason || '',
      branchId: payload.branchId,
    });

    console.log(' wasteTrackingService.logWaste - API response status:', res?.status);
    console.log(' wasteTrackingService.logWaste - API response data:', res?.data);

    return res?.data || res;

  } catch (error) {
    console.error(' wasteTrackingService.logWaste - Error status:', error?.response?.status);
    console.error(' wasteTrackingService.logWaste - Error data:', error?.response?.data);
    console.error(' wasteTrackingService.logWaste - Error message:', error?.message);
    console.error(' wasteTrackingService.logWaste - Full error:', error);

    throw error;
  }
},

 async getWasteEntries(filters = {}) {
  console.log(' Fetching waste entries:', filters);
  try {
    const res = await apiClient.get(ENDPOINTS.WASTE_TRACKING.LOG_ENTRIES, { params: filters });
    return Array.isArray(res) ? res : (res?.data || []);
  } catch (error) {
    console.error(' Get waste entries error:', error);
    throw error;
  }
},


  async getTodaysWaste(branchId) {
    if (USE_MOCK) {
      await delay(300);
      const today = new Date().toISOString().split('T')[0];
      // Use mock "today" as 2026-03-05 for consistent demo data
      return mockWasteEntries.filter((e) => e.createdAt.startsWith('2026-03-05'));
    }
    const res = await apiClient.get(ENDPOINTS.WASTE_TRACKING.TODAY, { params: { branchId } });
  return Array.isArray(res) ? res : (res?.data || []);
},

  async getStats(branchId) {
    if (USE_MOCK) {
      await delay(300);
      const totalWasteCount = mockWasteEntries.length;
      const wasteCost = mockWasteEntries.reduce((sum, e) => sum + e.costImpact, 0);
      // Count by category
      const categoryCounts = {};
      mockWasteEntries.forEach((e) => {
        categoryCounts[e.wasteCategory] = (categoryCounts[e.wasteCategory] || 0) + 1;
      });
      const topCategory = Object.entries(categoryCounts).sort((a, b) => b[1] - a[1])[0];
      const categoryLabel = WASTE_CATEGORIES.find((c) => c.value === topCategory?.[0])?.label || 'N/A';
      return {
        totalWasteCount,
        wasteCost,
        topCategory: categoryLabel,
        wasteVsRevenuePercent: 2.4, // Mock percentage
      };
    }
    const res = await apiClient.get(ENDPOINTS.WASTE_TRACKING.STATS, { params: { branchId } });
  return res?.data ?? res;
},

  async getAnalytics(branchId, period = 30) {
    if (USE_MOCK) {
      await delay(400);
      const dailyTrend = generateDailyTrend(period);

      // Top 5 wasted items
      const itemCosts = {};
      mockWasteEntries.forEach((e) => {
        itemCosts[e.itemName] = (itemCosts[e.itemName] || 0) + e.costImpact;
      });
      const topWastedItems = Object.entries(itemCosts)
        .sort((a, b) => b[1] - a[1])
        .slice(0, 5)
        .map(([name, cost]) => ({ name, cost }));

      // Waste by category
      const categoryColors = {
        spoilage: { bg: 'bg-red-500', text: 'text-red-600', light: 'bg-red-100' },
        over_preparation: { bg: 'bg-blue-500', text: 'text-blue-600', light: 'bg-blue-100' },
        damage: { bg: 'bg-slate-500', text: 'text-slate-600', light: 'bg-slate-100' },
        plate_waste: { bg: 'bg-violet-500', text: 'text-violet-600', light: 'bg-violet-100' },
        theft_shrinkage: { bg: 'bg-rose-500', text: 'text-rose-600', light: 'bg-rose-100' },
        other: { bg: 'bg-gray-400', text: 'text-gray-600', light: 'bg-gray-100' },
      };
      const catCosts = {};
      mockWasteEntries.forEach((e) => {
        catCosts[e.wasteCategory] = (catCosts[e.wasteCategory] || 0) + e.costImpact;
      });
      const totalCost = Object.values(catCosts).reduce((s, v) => s + v, 0);
      const wasteByCategory = Object.entries(catCosts)
        .sort((a, b) => b[1] - a[1])
        .map(([key, cost]) => ({
          key,
          label: WASTE_CATEGORIES.find((c) => c.value === key)?.label || key,
          cost,
          percent: Math.round((cost / totalCost) * 100),
          colors: categoryColors[key] || categoryColors.other,
        }));

      return { dailyTrend, topWastedItems, wasteByCategory };
    }
   const res = await apiClient.get(ENDPOINTS.WASTE_TRACKING.ANALYTICS, { 
    params: { branchId, period } 
  });
  return res?.data ?? res;
},

  async getInventoryItems(branchId) {
    if (USE_MOCK) {
      await delay(300);
      return [...mockInventoryItems];
    }
    const res = await apiClient.get(ENDPOINTS.WASTE_TRACKING.INVENTORY_ITEMS, { 
    params: { branchId } 
  });
  return Array.isArray(res) ? res : (res?.data || []);
},
};

export { WASTE_CATEGORIES };
export default wasteTrackingService;
